import { Action } from '@ngrx/store';

export enum CrudsActionType {
  GET = '[Crud] get',
  POST = '[Crud] post',
  FAILED = '[Crud] Failed',
}
export class CrudLoadAction implements Action {
  readonly type = CrudsActionType.GET;
  //add an optional payload
  constructor(public payload: any) {}
}

export class CrudPostAction implements Action {
  readonly type = CrudsActionType.POST;
  //add an optional payload
  constructor(public payload: any) {}
}


export class CrudFailedAction implements Action {
  readonly type = CrudsActionType.FAILED;
  //add an optional payload
  constructor(public payload: any) {}
}

export type CrudStateAction = CrudLoadAction | CrudFailedAction | CrudPostAction;